import { render } from "./MenuTitle.vue?vue&type=template&id=26aa8648"
import script from "./MenuTitle.vue?vue&type=script&lang=js"
export * from "./MenuTitle.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__